import { render, staticRenderFns } from "./AlertQueue.vue?vue&type=template&id=2863b7a8&"
import script from "./AlertQueue.vue?vue&type=script&lang=js&"
export * from "./AlertQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports